import {
    RequestConfig,
} from 'app/types/request.types'

import useRequestTable from 'app/hooks/useRequestTable'

import RichTable from 'app/shared-components/RichTableReduxWrapper'
import Card from 'app/shared-components/Card'
import {
    RequestKeys,
} from 'app/hooks/useRequest'

import {
    RichTableColumns,
} from 'app/types/richtable.types'
import getColumns from './ChangeHistory.columns'
import useStyles from './ChangeHistory.styles'
import {
    Modification,
} from './ChangeHistory.types'

export default function ChangeHistory({
    id,
    requestKey,
    config,
    configName,
    name,
    labelPrefixForChangedColumn,
    title,
    columns,
}: Readonly<{
    id: number,
    config: (args: Record<string, any>) => RequestConfig,
    configName: string,
    name: string,
    requestKey: RequestKeys,
    labelPrefixForChangedColumn: string[],
    title?: string,
    columns?: RichTableColumns[]
}>) {
    const {
        classes,
    } = useStyles()
    const {
        loadData: load,
    } = useRequestTable<Modification>({
        key: requestKey,
        params: {
            id,
        },
        config,
        enabled: Boolean(id),
    })

    return (
        <Card
            title={title || 'Change History'}
        >
            <RichTable
                configName={configName}
                name={name}
                load={load}
                columns={columns || getColumns(labelPrefixForChangedColumn)}
                uniqField="id"
                className={classes.tableContent}
                classNames={{
                    contentWrapper: classes.tableContentWrapper,
                }}
            />
        </Card>
    )
}
